import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "my-4" }
const _hoisted_2 = { class: "my-4" }
const _hoisted_3 = {
  key: 0,
  class: "my-4"
}
const _hoisted_4 = { class: "grey--text" }
const _hoisted_5 = {
  key: 1,
  class: "my-4"
}
const _hoisted_6 = { class: "d-flex align-center" }
const _hoisted_7 = { class: "d-flex align-center" }
const _hoisted_8 = { class: "mr-4" }
const _hoisted_9 = { class: "my-4" }
const _hoisted_10 = { class: "mb-4" }
const _hoisted_11 = { class: "d-flex align-center" }
const _hoisted_12 = { style: {"width":"120px"} }
const _hoisted_13 = { class: "mt-8 mb-4" }
const _hoisted_14 = { class: "d-flex align-center" }
const _hoisted_15 = { class: "d-flex align-center" }
const _hoisted_16 = { class: "mt-8 d-flex" }
const _hoisted_17 = { class: "d-flex flex-column align-center" }
const _hoisted_18 = {
  key: 0,
  class: "mb-2",
  style: {"width":"300px"}
}
const _hoisted_19 = { class: "mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t('nap.createNapCheck')), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('nap.selectFromPattern')), 1),
      _createElementVNode("div", null, [
        (_ctx.isFetchingTemplate)
          ? (_openBlock(), _createBlock(_component_v_progress_linear, {
              key: 0,
              indeterminate: "",
              color: "primary",
              class: "my-8"
            }))
          : _createCommentVNode("", true)
      ]),
      (_ctx.napTemplates.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_v_card, {
              variant: "outlined",
              class: "pa-4 d-flex align-center justify-center"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('nap.noPatternRegistered')), 1)
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.napTemplates, (t) => {
              return (_openBlock(), _createBlock(_component_v_card, {
                variant: "outlined",
                class: "pa-3 mb-2",
                key: t.napTemplateId
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(t.templateTitle), 1),
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t('common.class')), 1)
                    ]),
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      color: "primary",
                      class: "mr-2",
                      variant: "flat",
                      onClick: ($event: any) => (_ctx.selectTemplate(t))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('nap.select')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_v_btn, {
                      color: "red",
                      class: "mr-2",
                      variant: "outlined",
                      onClick: ($event: any) => (_ctx.openDeleteModal(t))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.delete')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]))
    ]),
    _createVNode(_component_v_divider, { class: "my-4" }),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.$t('nap.newCreate')), 1),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "4" }, {
            default: _withCtx(() => [
              _createElementVNode("h4", null, _toDisplayString(_ctx.$t('common.date')), 1),
              _createVNode(_component_date_picker, {
                modelValue: _ctx.date,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.date) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "4" }, {
            default: _withCtx(() => [
              _createElementVNode("h4", null, _toDisplayString(_ctx.$t('nap.recorder')), 1),
              _createVNode(_component_v_select, {
                variant: "outlined",
                density: "compact",
                "hide-details": "",
                items: _ctx.staffOptions,
                "item-value": "userId",
                "item-title": "name",
                modelValue: _ctx.recorderId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.recorderId) = $event))
              }, null, 8, ["items", "modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { class: "mb-4" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "3" }, {
            default: _withCtx(() => [
              _createElementVNode("h4", null, _toDisplayString(_ctx.$t('nap.selectClass')), 1),
              _createVNode(_component_v_select, {
                variant: "outlined",
                density: "compact",
                "hide-details": "",
                multiple: "",
                items: _ctx.classOptions,
                "item-title": "title",
                "item-value": "value",
                modelValue: _ctx.classIds,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.classIds) = $event))
              }, null, 8, ["items", "modelValue"]),
              (_ctx.isFetchingClasses)
                ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                    key: 0,
                    indeterminate: "",
                    color: "primary"
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "3" }, {
            default: _withCtx(() => [
              _createElementVNode("h4", null, _toDisplayString(_ctx.$t('nap.selectAge')), 1),
              _createVNode(_component_v_select, {
                variant: "outlined",
                density: "compact",
                "hide-details": "",
                multiple: "",
                items: _ctx.ageOptions,
                "item-value": "age",
                "item-title": "label",
                modelValue: _ctx.ages,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ages) = $event))
              }, null, 8, ["items", "modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "3" }, {
            default: _withCtx(() => [
              _createElementVNode("h4", null, _toDisplayString(_ctx.$t('nap.checkInterval')), 1),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_v_select, {
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "",
                    class: "mr-2",
                    items: _ctx.intervalOptions,
                    "item-value": "value",
                    "item-title": "label",
                    modelValue: _ctx.inteval,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.inteval) = $event))
                  }, null, 8, ["items", "modelValue"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("h4", _hoisted_13, _toDisplayString(_ctx.$t('nap.selectChildren')), 1),
      _createElementVNode("div", null, [
        (_ctx.isFetchingChildren)
          ? (_openBlock(), _createBlock(_component_v_progress_linear, {
              key: 0,
              indeterminate: "",
              color: "primary",
              class: "my-8"
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "6" }, {
            default: _withCtx(() => [
              _createElementVNode("h5", null, _toDisplayString(_ctx.$t('nap.selectIndividually')), 1),
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.childrenOptions, (child) => {
                  return (_openBlock(), _createBlock(_component_v_card, {
                    variant: "outlined",
                    class: "pa-2 mb-2",
                    key: child.classId
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", null, _toDisplayString(child.lastName) + " " + _toDisplayString(child.firstName), 1),
                        _createVNode(_component_v_spacer),
                        _createElementVNode("div", null, [
                          _createVNode(_component_v_btn, {
                            variant: "outlined",
                            small: "",
                            color: "primary",
                            onClick: ($event: any) => (_ctx.selectChild(child))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('nap.select')), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "6" }, {
            default: _withCtx(() => [
              _createElementVNode("h5", null, _toDisplayString(_ctx.$t('nap.selectedChildren')), 1),
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedChildren, (child) => {
                  return (_openBlock(), _createBlock(_component_v_card, {
                    variant: "outlined",
                    class: "pa-2 mb-2",
                    key: child.classId
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", null, _toDisplayString(child.lastName) + " " + _toDisplayString(child.firstName), 1),
                        _createVNode(_component_v_spacer),
                        _createElementVNode("div", null, [
                          _createVNode(_component_v_btn, {
                            variant: "outlined",
                            small: "",
                            onClick: ($event: any) => (_ctx.removeChild(child))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('nap.deselect')), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_v_divider, { class: "my-8" }),
    _createElementVNode("div", null, [
      (_ctx.isCreating)
        ? (_openBlock(), _createBlock(_component_v_progress_linear, {
            key: 0,
            indeterminate: "",
            color: "primary",
            class: "my-8"
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_v_spacer),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_v_checkbox, {
          class: "mb-2",
          label: _ctx.$t('nap.registerAsPattern'),
          modelValue: _ctx.willCreateTemplate,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.willCreateTemplate) = $event)),
          color: "primary"
        }, null, 8, ["label", "modelValue"]),
        (_ctx.willCreateTemplate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.templateTitle,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.templateTitle) = $event)),
                variant: "outlined",
                "full-width": "",
                label: _ctx.$t('nap.patternName')
              }, null, 8, ["modelValue", "label"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_v_btn, {
          "x-large": "",
          variant: "flat",
          color: "primary",
          disabled: !_ctx.isCreateValid || _ctx.isCreating,
          onClick: _ctx.create
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.create')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      _createVNode(_component_v_spacer)
    ]),
    _createVNode(_component_v_dialog, {
      "model-value": _ctx.templateToDelete !== null,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = (val) => { if (!val) _ctx.templateToDelete = null }),
      "max-width": "480"
    }, {
      default: _withCtx(() => [
        (_ctx.templateToDelete)
          ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('nap.confirmDelete')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_19, [
                      _createTextVNode(_toDisplayString(_ctx.$t('nap.templateName')) + ": ", 1),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.templateToDelete.templateTitle), 1)
                    ]),
                    (_ctx.isDeletingTemplate)
                      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                          key: 0,
                          indeterminate: "",
                          color: "red",
                          class: "my-8"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      color: "grey",
                      variant: "flat",
                      size: "large",
                      disabled: _ctx.isDeletingTemplate,
                      onClick: _cache[7] || (_cache[7] = () => _ctx.templateToDelete = null)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_v_btn, {
                      color: "red",
                      variant: "flat",
                      size: "large",
                      disabled: _ctx.isDeletingTemplate,
                      onClick: _ctx.deleteTemplate
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.delete')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"]),
                    _createVNode(_component_v_spacer)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["model-value"])
  ]))
}